import { Navigate } from 'react-router-dom'

export const PrivateRoute = ({ children, isLogged }) => {
  if (!isLogged) {
    return <Navigate to="/login" />
  }
  return children
}
